import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { WarehouseModals } from "@/components/warehouse/warehouse-modals";
import WarehouseTable from "@/components/warehouse/warehouse-table";
import { useTranslate } from "@/hooks/use-translate";
import useAppStore from "@/store";
import { Plus } from "lucide-react";

export const Route = createFileRoute("/(dasboard)/inventory/warehouses")({
  component: WarehousesPage,
});

function WarehousesPage() {
  const store = useAppStore();
  const { t } = useTranslate();
  return (
    <>
      <WarehouseModals />
      <div className="max-w-6xl mx-auto">
        <header className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-4 gap-4">
          <h2 className="text-2xl font-semibold"> {t("Warehouses")} </h2>
          <Button
            onClick={() => {
              store.display.show("create_warehouse");
            }}
          >
            <Plus className="w-4 h-4" />
            {t("Add a warehouse")}
          </Button>
        </header>

        <WarehouseTable />
      </div>
    </>
  );
}
